import { statusTickets } from './data';

export const pageSize = 5;
export const ITEM_PER_PAGE = 20;
export const ITEM_PER_PAGE_RESPONDER = 10;
export const ITEM_PER_PAGE_MONITORING = 20;

export const filterArchivedContactGroup = (el) => {
  return !el.archived;
};

export const filterDidsInitial = {
  limit: 20,
  offset: 0,
  requireDid: false,
  name: '',
  routeId: '',
  country: '',
};

export const filterDomainInitial = {
  limit: 20,
  offset: 0,
  name: '',
  active: true,
  hasActiveDomain: true,
};

export const filterNotificationInitial = {
  offset: 0,
  limit: 5,
  status: true,
  page: 1,
};

export const filterContactInitial = {
  name: '',
  size: ITEM_PER_PAGE,
  page: 0,
  country: '',
};

export const filterTicketInitial = {
  title: '',
  limit: 20,
  offset: 0,
  status: statusTickets[0].value,
};

export const filterCampaignDomainInitial = {
  limit: 5,
  offset: 0,
};

export const filterResponderDomainInitial = {
  page: 0,
  size: 5,
};

export const filterLoadDomainDetailInitial = {
  sortFields: 'deliveryRate',
  sortDirections: 'DESC',
  pageSize: 50,
  pageIndex: 0,
  pageCount: 1,
  searchValues: '',
};

export const filterContactDetailInitial = {
  pageSize: 50,
  page: 1,
  pageIndex: 0,
  searchValue: '',
  sortFields: 'creation_date',
  sortDirections: 'desc',
};

export const filterPremiumOrderInitial = {
  // status: "",
  // orderDirection: "",
  // orderBy: "",
};
